<script setup lang="ts">
import { useAccess } from '../composables/useAccessRol';
import type { AccessRolAction, AccessRolSection } from '../index';

const props = defineProps<{
  section: AccessRolSection;
  actions?: AccessRolAction[];
}>();

const { hasAccess } = useAccess({
  section: props.section,
  actions: props.actions,
});
</script>

<template>
  <template v-if="hasAccess">
    <slot />
  </template>
</template>
